// // Search
// const search = () => {
//   var filter, tr, td, i, txtValue, allText;
//   const input = document.getElementById("myInput");
//   const table = document.getElementById("kt_datatable_example_5");
//   const tbody = document.getElementById("kt_datatable_example_5").childNodes[1];

//   filter = input?.value.toUpperCase();
//   for (tr of table?.getElementsByTagName("tr"))
//     for (td of tr?.getElementsByTagName("td"))
//       if (td) {
//         txtValue = td.textContent || td.innerText;
//         if (txtValue?.toUpperCase()?.indexOf(filter) > -1) {
//           tr.style.display = "";
//           break;
//         } else {
//           tbody.innerHTML = "<p>No Data Found</p>";
//         }
//       }
// };
// export default search;
// Search
const search = () => {
  var filter, tr, td, i, txtValue, allText, j;
  const input = document.getElementById("myInput");
  const table = document.getElementById("kt_datatable_example_5");
  filter = input?.value.toUpperCase();
  for (tr of table?.getElementsByTagName("tr"))
    for (td of tr?.getElementsByTagName("td"))
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue?.toUpperCase()?.indexOf(filter) > -1) {
          tr.style.display = "";
          break;
        } else tr.style.display = "none";
      }
};
export default search;
